import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Brand from '../../components/Common/Brand';
import CounterStyleThree from '../../components/Elements/Counter/CounterStyleThree';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleService from '../../components/Service/SingleService';
import ProgressBar from '../../components/Elements/Progress/ProgressBar';
import ScrollToTop from '../../components/Common/ScrollTop';

import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';

import bannerbg from '../../assets/img/breadcrumbs/3.jpg';
import aboutImg1 from '../../assets/img/about/1.jpg';
import whyChooseUsImg from '../../assets/img/choose/3.png';

import serviceIcon1 from '../../assets/img/service/style7/1.png';
import serviceIcon2 from '../../assets/img/service/style7/2.png';
import serviceIcon3 from '../../assets/img/service/style7/3.png';

const SoftwareDevelopment = () => {
    const [serviceData, setServiceData] = useState(null);

    useEffect(() => {
        fetch('https://yautiktechnology.com/api/service/Custom')
            .then(response => response.json())
            .then(data => setServiceData(data))
            .catch(error => console.error('Error fetching service data:', error));
    }, []);

    if (!serviceData) {
        return <div>Loading...</div>;
    }

    return (
        <React.Fragment>
            <Header parentMenu="page" secondParentMenu="Custom Development" activeMenu="/services" />
            <SiteBreadcrumb
                pageTitle="Custom Development"
                titleClass="page-title"
                pageName="Services"
                breadcrumbsImg={bannerbg}
            />

            {/* About Section Start */}
            <div className="rs-about pt-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pr-40 md-pr-14 md-mb-50">
                            <SectionTitle
                                sectionClass="sec-title4"
                                subtitleClass="sub-text"
                                subtitle={serviceData.serviceType}
                                titleClass="title"
                                title={serviceData.heading}
                                effectClass="heading-line"
                            />
                            <SectionTitle
                                sectionClass="sec-title4"
                                descClass="desc desc-big"
                                description={serviceData.description}
                            />
                            <SectionTitle
                                sectionClass="sec-title4"
                                descClass="desc desc-big"
                                titleClass="title1"
                                title={serviceData.keyFeature}
                            />
                            <ul className="key-features">
                                <li>
                                    <strong>{serviceData.subHeading1}:</strong> {serviceData.subHeadingDesc1}
                                </li>
                                <li>
                                    <strong>{serviceData.subHeading2}:</strong> {serviceData.subHeadingDesc2}
                                </li>
                                <li>
                                    <strong>{serviceData.subHeading3}:</strong> {serviceData.subHeadingDesc3}
                                </li>
                                <li>
                                    <strong>{serviceData.subHeading4}:</strong> {serviceData.subHeadingDesc4}
                                </li>
                                <li>
                                    <strong>{serviceData.subHeading5}:</strong> {serviceData.subHeadingDesc5}
                                </li>
                            </ul>
                            <div className="btn-part mt-46">
                                <Link to="/contact" className="readon learn-more">
                                    Contact Us
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="images">
                                <img src={aboutImg1} alt="Software Details" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About Section End */}

        
            {/* Services Section Start */}
            <div className="rs-services style5 pt-120 pb-120 md-pt-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 md-mb-30">
                            <SingleService
                                itemClass="services-item"
                                serviceImage={serviceIcon1}
                                Title={serviceData.expHeading}
                                Text={serviceData.expDesc}
                            />
                        </div>
                        <div className="col-lg-4 md-mb-30">
                            <SingleService
                                itemClass="services-item"
                                serviceImage={serviceIcon2}
                                Title={serviceData.processHeading}
                                Text={serviceData.processDesc}
                            />
                        </div>
                        <div className="col-lg-4">
                            <SingleService
                                itemClass="services-item"
                                serviceImage={serviceIcon3}
                                Title={serviceData.ideaHeading}
                                Text={serviceData.ideaDesc}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* Services Section End */}


            {/* Why Choose US Section Start */}
            <div className="rs-about gray-bg pt-120 pb-120 md-pt-80 md-pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 pr-46 md-pr-15 md-mb-50">
                            <div className="choose-img">
                                <img className="main" src={whyChooseUsImg} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <SectionTitle
                                sectionClass="sec-title mb-30"
                                subtitleClass="sub-text choose"
                                subtitle="Why Choose Us"
                                titleClass="title pb-20"
                                title={serviceData.businessHeading}
                                descClass="desc"
                                description={serviceData.businessDesc}
                            />
                            <div className="row">
                                <div className="col-lg-10">
                                    <div className="rs-skillbar style1 modify1">
                                        <div className="cl-skill-bar">
                                            <ProgressBar
                                                completed={92}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Software Development"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={80}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Cyber Security"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={95}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Artificial Intelligence"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={78}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Web Development"
                                                ProgressParent="main-div"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Why Choose US Section End */}


            <CounterStyleThree />
            <Brand />
            <ScrollToTop />
            <Footer />
            <SearchModal />
        </React.Fragment>
    );
};

export default SoftwareDevelopment;
